import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: Theme.primaryMargin,
        paddingTop: Device.isTabletOrWeb ? 100 : 20
    },
    button: {
        marginTop: 40
    },
    contentConteiner: {
        width: Device.isTabletOrWeb ? '50%' : '100%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    }
};

export default StyleSheet.create(baseStyles);
